<template>
  <div class="footer">
    <van-tabbar route v-model="active" v-if='loading' :active-color='isNewMode?mark_info.color:""'>
      <van-tabbar-item replace to="/">
        <span>首页</span>
          
        <img slot="icon" slot-scope="props" v-if="isNewMode"  :src=" 
            props.active && icon_list
              ? icon_list[0]
              : ossImgPath + 'home_new.png'
          " />
        <img slot="icon" slot-scope="props" v-else :src="
            props.active && imgPathLi
              ? imgPathLi + 'home1.png'
              : imgPath + 'home.png'
          " />
      </van-tabbar-item>
      <van-tabbar-item replace to="/classify">
        <span>分类</span>
		<img slot="icon" slot-scope="props" v-if="isNewMode"  :src="
		    props.active && icon_list
		      ?icon_list[1]
		      : ossImgPath + 'class_new.png'
		  " />
        <img slot="icon" slot-scope="props" v-else :src="
            props.active && imgPathLi
              ? imgPathLi + 'class1.png'
              : imgPath + 'class.png'
          " />
      </van-tabbar-item>
     
	  <van-tabbar-item replace to="/Ranking" v-if="isNewMode">
	    <span>排行榜</span>
	    <img slot="icon" slot-scope="props" :src="
	        props.active
	          ? icon_list[2]
	          : ossImgPath + 'Columnar1.png'
	      " />
	  </van-tabbar-item>
      <van-tabbar-item replace to="/cart">
        <span>购物车</span>
		<img slot="icon" slot-scope="props" v-if="isNewMode"  :src="
		    props.active && icon_list
		      ? icon_list[3]
		      : ossImgPath + 'car_new.png'
		  " />
        <img slot="icon" slot-scope="props" v-else :src="
            props.active && imgPathLi
              ? imgPathLi + 'shopCart1.png'
              : imgPath + 'shopCart.png'
          " />
      </van-tabbar-item>
      <van-tabbar-item replace to="/personalCenter">
        <span>我的</span>
		<img slot="icon" slot-scope="props" v-if="isNewMode"  :src="
		    props.active && icon_list
		      ? icon_list[4]
		      : ossImgPath + 'my_new.png'
		  " />
        <img slot="icon" slot-scope="props" v-else :src="
            props.active && imgPathLi
              ? imgPathLi + 'center1.png'
              : imgPath + 'center.png'
          " />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import { sendRequest } from '@/assets/public'
import { removeItem } from '../utils/storage'
  export default {

    data() {
      return {
        active: 0,
        imgPathLi: '',
        storeInfo: {},
        loading: false,
        isNewMode: localStorage.getItem('isNewMode') || 0,
        isLogin: localStorage.getItem('token'), //是否登录
        icon_list:[],
        mark_info:{}
      }
    },
    // mounted(){

    // },
   
    mounted() {

        if (localStorage.getItem('isNewMode')) {
            this.isNewMode = 1
          }
        sendRequest('user/storeInfo').then((result) => {

          if (result.status == 200) {
           
          
            localStorage.setItem('is_allinpay', result.content.store.is_allinpay)

            let mark_id =
              result.content.store.mark_id <= 10 ||
                result.content.store.mark_id > 20
                ? 3
                : result.content.store.mark_id % 10 == 0
                  ? 10
                  : result.content.store.mark_id % 10
              this.imgPathLi = this.ossImgPath + mark_id + '/'
              this.storeInfo = result.content.store
              this.loading = true

          console.log(result.content.store.mark_type,'新版切换模板') 
              if(result.content.store.mark_type==1){//新版切换模板--2024-05015
              // return
                    sendRequest('store/getStoreMarkList',{}).then((ress) => {
                    if(ress.status==200){

                        var array = ress.content
                        array.forEach((item)=> {

                            if(item.isusing==1){
                              console.log('====',item.isusing,'=====0000')
                              this.icon_list=item.icon_list
                              return
                            }
                            if(result.content.store.mark_id==21){
                              this.icon_list=ress.content[0].icon_list
                              return
                            }
                            
                           
                        });
         
                    }

                  console.log(ress,'wwwww')
                })  

              }

          

            return
          }
        })
	  
    },
  }
</script>
<style scoped>
  .footer {
    border-top: 1px solid #e1e1e1;
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100%;
    z-index: 9;
  }

  .van-tabbar-item--active {
    color: #333;
  }

  .van-tabbar-item {
    position: relative;
  }

  .van-tabbar-item__text img {
    position: absolute;
    width: 2.74rem;
    height: 2.36rem;
    top: -0.4rem;
    left: 0;
    z-index: 9;
  }
</style>